export default "__VITE_ASSET__rocLB4tb__"